import { render, staticRenderFns } from "./Interviews.vue?vue&type=template&id=b1825f3a&"
import script from "./Interviews.vue?vue&type=script&lang=js&"
export * from "./Interviews.vue?vue&type=script&lang=js&"
import style0 from "./Interviews.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports